import { useEffect, useState } from 'react';

import Modal from '@/components/Modal';
import { useTheme } from '@/theme';
import { AspectRatio } from '@/models/customJSON';
import { isDiscordOnMobile } from '@/components/DiscordAuthFlow/useDiscord';
import { getDeviceType } from '@/utils/mobile';

function getScreenAspectRatio() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    return height ? width / height : 0;
}

// Accepts either a ratio ("16:9") or a decimal ("1.777")
function parseAspectRatio(value?: string): number | undefined {
    if (!value) return undefined;

    const [width, height] = value.split(':');
    const parsed = height === undefined ? Number(width) : Number(width) / Number(height);

    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

export default function AspectRatioModal() {
    const [aspectRatio, setAspectRatio] = useState(getScreenAspectRatio);
    const theme = useTheme();

    const ar = theme.metadata?.customJSON?.aspectRatio as AspectRatio | undefined;

    useEffect(() => {
        function onResize() {
            setAspectRatio(getScreenAspectRatio());
        }

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const minAspectRatio = parseAspectRatio(ar?.min);
    const isTooNarrow = minAspectRatio !== undefined && aspectRatio < minAspectRatio;
    const isVisible = !!ar && ar.enabled !== false && isTooNarrow;

    const deviceType = getDeviceType();
    // const deviceType = 'mobile';

    let notice = ar?.desktopNotice;
    let imgUrl = '/assets/global/images/widen.svg';
    let imgWidth = 80;

    if (deviceType === 'mobile') {
        notice = ar?.mobileNotice;
        imgUrl = '/assets/global/images/rotate.svg';
        imgWidth = 40;
    }

    if (deviceType === 'tablet') {
        notice = ar?.tabletNotice;
        imgUrl = '/assets/global/images/rotate.svg';
        imgWidth = 40;
    }

    return (
        <Modal isVisible={isVisible} hasCloseButton={false}>
            <div>
                <img
                    src={imgUrl}
                    alt=""
                    style={{
                        width: imgWidth,
                        margin: 'auto',
                        paddingBottom: 20,
                    }}
                />
                <p>{notice}</p>
            </div>
        </Modal>
    );
}
